import { html, LitElement, type TemplateResult } from "lit";
import { state } from "lit/decorators.js";

export class GWPStickyNotification extends LitElement {
    @state()
    private gwpNoficationVisible = false;

    @state()
    private checkoutNoficationVisible = false;

    @state()
    private hasFreeGift = false;

    cartContainer: Element;
    gwpSelector: Element;
    cartCheckoutContainer: Element;
    checkoutButton: Element;

    constructor() {
        super();

        window.addEventListener(
            "gwp-validator:has-free-gift",
            (event: CustomEvent<Event>) => {
                this.hasFreeGift = event.detail[0].hasFreeGift;
            },
        );
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.cartContainer = document.querySelector(
            ".frenzy_horizontal_popup .sidebar_fix",
        );
        this.gwpSelector = document.querySelector("gwp-selector");
        this.cartCheckoutContainer = document.querySelector(
            "[data-cart-checkout]",
        );
        this.checkoutButton = document.querySelector(
            '[slot="checkout-notification"]',
        );
        this.cartContainer?.addEventListener(
            "scroll",
            this.stickyNotificationCallback.bind(this),
        );
    }

    private stickyNotificationCallback(): void {
        const gwpRecTop = this.gwpSelector?.getBoundingClientRect().top;
        const checkoutRectTop =
            this.cartCheckoutContainer?.getBoundingClientRect().top;
        this.gwpNoficationVisible =
            gwpRecTop >= window.innerHeight - this.checkoutButton.clientHeight;
        this.checkoutNoficationVisible = checkoutRectTop >= window.innerHeight;
    }

    render(): TemplateResult {
        return html`
      ${this.gwpNoficationVisible && this.hasFreeGift ? html`<slot name="gwp-notification"></slot>` : null}
      ${this.checkoutNoficationVisible ? html`<slot name="checkout-notification"></slot>` : null}
    `;
    }
}

customElements.get("gwp-sticky-notification") ||
    customElements.define("gwp-sticky-notification", GWPStickyNotification);
